import React from 'react'
import './HomeProducts.css'
import Data from '../../data/Data'

const HomeProducts = () => {
    return (
        <div className='home-products' id="products">
            <h1 className="home-products-heading">SEE OUR PRODUCTS</h1>
            <div className="home-products-card-container">
                <div className="home-products-card">
                    <img src={Data.product1Image} className="home-products-image"/>
                    <div className="home-products-card-info"> 
                        <h1>{Data.product1Header}</h1>
                        <p>{Data.product1Description}</p>
                    </div>
                </div>
                <div className="home-products-card">
                    <img src={Data.product2Image} className="home-products-image"/>
                    <div className="home-products-card-info"> 
                        <h1>{Data.product2Header}</h1>
                        <p>{Data.product2Description}</p>
                    </div>
                </div>
                <div className="home-products-card">
                    <img src={Data.product3Image} className="home-products-image"/>
                    <div className="home-products-card-info"> 
                        <h1>{Data.product3Header}</h1>
                        <p>{Data.product3Description}</p>
                    </div>
                </div>
                <div className="home-products-card">
                    <img src={Data.product4Image} className="home-products-image"/>
                    <div className="home-products-card-info"> 
                        <h1>{Data.product4Header}</h1>
                        <p>{Data.product4Description}</p>
                    </div>
                </div>
            </div>
        </div>
    )
}

export default HomeProducts
